var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQUlEQVR42mMYBTQGjMHnzoAw2ZoZLCaAMYhNnmbNfBCGG0KO7eiuSCPJAGgYkGIAAiBpSENmkxqWacjs0XSJHQAAZiswxSOXqdMAAAAASUVORK5CYII=";
  export default img;